// import { EnumLiteralsOf } from 'utilities'
// import { Image } from 'models';

// export interface Brand {
//   id?: number;
//   name: string;
//   websiteUrl: string;
//   tags: string;
//   info: string;
//   images: Image[];
//   relatedMedia: any[];
// }

// export const sourceTypes = {
//   studio: 'studio' as 'studio',
//   marketplace: 'marketplace' as 'marketplace'
// }
// export type SourceTypes = EnumLiteralsOf<typeof sourceTypes>;
export enum SourceTypes {
  STUDIO = 'studio',
  MARKETPLACE = 'marketplace',
  COCOS = 'cocos',
  TECH = 'tech marketplace'
}
